import { MapPinned, Info } from 'lucide-react';
import Image from 'next/image';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import config from '@/lib/config';

interface ProductImageProps {
  src: string;
  alt: string;
  className?: string;
  productName: string;
}

interface ShippingInfoPopoverProps {
  productName: string;
}

function ShippingInfoPopover({ productName }: ShippingInfoPopoverProps) {
  return (
    <PopoverContent className="w-72">
      <div className="flex items-start gap-3">
        <Info className="w-4 h-4 text-orange-800" />
        <div className="text-xs">
          <p className="mb-2 text-orange-800">This {productName} ships beyond Rochester.</p>
          <p className="leading-relaxed">
            {config.allowedStates.map((state, index) => (
              <span key={state.ab} className="font-medium">
                {state.name}
                {index < config.allowedStates.length - 1 ? ', ' : ''}
              </span>
            ))}
          </p>
        </div>
      </div>
    </PopoverContent>
  );
}

export function ProductImage({ src, alt, className, productName }: ProductImageProps) {
  const showExtendedAvailability = productName === 'Fruit Jam' || productName === 'Kremas';
  return (
    <div className={`aspect-video bg-white overflow-hidden px-6 py-2 relative ${className || ''}`}>
      {showExtendedAvailability && (
        <Popover>
          <PopoverTrigger asChild>
            <button className="absolute top-0 right-0 p-2 z-30 flex items-center gap-2">
              <div className="rounded-full p-2 bg-gradient-to-br from-amber-50 via-orange-50 to-rose-50 text-xs">
                Ships beyond Rochester, NY
              </div>
              <MapPinned className="w-3 h-3 stroke-orange-600" />
            </button>
          </PopoverTrigger>
          <ShippingInfoPopover productName={productName} />
        </Popover>
      )}
      <Image
        src={src}
        alt={alt}
        height={480}
        width={480}
        className="w-full h-full object-contain md:hover:scale-110 transition-transform duration-500"
      />
    </div>
  );
}
